import { config } from '../_config';
import {updateService as updateS} from './update.service';
import {fakeUpdateService as updateFS} from './fake.update.service';
import { fakeLinkService as linksFS } from "./fake.links.serivce";
import { linkService as linksS } from "./links.service";
import { PatchNotesService as patchNotesS } from "./patch.notes.service";
import { ImportService as importS } from "./import.service";
import { IUpdateService, ILinksService, ISettingDownloadService, IUpdateComponent, IPatchNotesComponent, IImportComponents, ISecureService } from '../_types/interfaces';
import { settingService as settingS } from './setting.download.service';
import { secureServices as secureS } from './secure.service';
import { fakeSettingService as settingFS} from './fake.setting.download.service';
import { updateService as componentS } from './components.service';
import { fakeUpdateService as componentFS} from './fake.components.service';
import { fakePatchNotesService as patchNotesFS} from './fake.patch.notes.service';
import { fakeImportService as importFS} from './fake.import.service';
import { fakeSecureServices as secureFS} from './fake.secure.service';

export let updateService: IUpdateService;
export let updateComponent: IUpdateComponent;
export let linkService: ILinksService;
export let settingService: ISettingDownloadService;
export let patchNotes: IPatchNotesComponent;
export let importService: IImportComponents;
export let secureService: ISecureService;

if (config.useFake === true) {
    updateService = updateFS;
    linkService = linksFS;
    settingService = settingFS
    updateComponent = componentFS
    patchNotes = patchNotesFS
    importService = importFS
    secureService = secureFS
} else {
    updateService = updateS;
    linkService = linksS;
    settingService = settingS
    updateComponent = componentS
    patchNotes = patchNotesS
    importService = importS
    secureService = secureS
}